const Config = {
  // Environment detection
  STAGE: process.env.REACT_APP_STAGE || 'dev',

  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_URL ,
  AUTH_URL: process.env.REACT_APP_AUTH_URL,
  CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI,

  // Static configuration
  SPECIAL_LOCATION_ID: process.env.REACT_APP_SPECIAL_LOCATION_ID,
  ATHENA_PRAC_ID: process.env.REACT_APP_ATHENA_ID,

  formTypes: [
    "Patient Registration",
    "Demographics",
    "SurgeryForm",
    "SurgeryConsent",
    "InjectionConsent"
  ],

  ACTIONID: {
    'edit': process.env.REACT_APP_EDIT_ACTION_ID || '9',
    'view': process.env.REACT_APP_VIEW_ACTION_ID || '10',
  },

  // Environment helpers
  get IS_PRODUCTION() {
    return this.STAGE === 'prod';
  },

  get IS_DEVELOPMENT() {
    return this.STAGE === 'dev';
  },

  get IS_STAGING() {
    return this.STAGE === 'staging';
  },

  // User data getters
  get NAME() {
    try {
      const userDetails = JSON.parse(localStorage.getItem("digital-form-user_details")) || {};
      return userDetails.name || "";
    } catch (error) {
      if (!this.IS_PRODUCTION) {
        console.warn('Error parsing user details:', error);
      }
      return "";
    }
  },

  get USERNAME() {
    return `${this.NAME}`.trim();
  },

  // Configuration validation
  validate() {
    const required = ['API_BASE_URL', 'AUTH_URL', 'CLIENT_ID', 'REDIRECT_URI'];
    const missing = required.filter(key => !this[key]);

    if (missing.length > 0) {
      console.error('Missing required environment variables:', missing);
      return false;
    }

    // Warn about HTTP in production
    if (this.IS_PRODUCTION && this.REDIRECT_URI?.startsWith('http://')) {
      console.warn('Production should use HTTPS for redirect URI');
    }

    return true;
  }
};

// Validate on module load
Config.validate();

export default Config;